import Box from '@mui/material/Box';
import { makeStyles } from 'tss-react/mui';
import Typography from '@mui/material/Typography';
import PropTypes from 'prop-types';
import React from 'react';

const useTabPanelStyles = makeStyles()(theme => ({
  box: {
    backgroundColor: theme.palette.background.default,
  },
}));

export default function TabPanel(props) {
  const { classes } = useTabPanelStyles();

  const { children, value, index, ...other } = props;

  return (
    <Typography
      component="div"
      role="tabpanel"
      hidden={value !== index}
      id={`nav-tabpanel-${index}`}
      aria-labelledby={`nav-tab-${index}`}
      {...other}
    >
      <Box className={classes.box}>{children}</Box>
    </Typography>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};
